import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SSOService } from '../../services/sso.service';
import { from, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

export const authGuard: CanActivateFn = (): Observable<boolean> => {
  const router = inject(Router);
  const ssoService = inject(SSOService);
  const platformId = inject(PLATFORM_ID);
  
  console.log('Auth Guard: Checking authentication...');
  
  // On server-side rendering, allow access (will be checked again on client)
  if (!isPlatformBrowser(platformId)) {
    console.log('Auth Guard: SSR environment, allowing access');
    return of(true);
  }
  
  // Check immediate authentication state first
  if (ssoService.isAuthenticated()) {
    console.log('Auth Guard: User is authenticated');
    return of(true);
  }

  // Check traditional token as fallback
  const token = localStorage.getItem('token');
  if (token && token.trim() !== '') {
    console.log('Auth Guard: Found legacy token, allowing access');
    return of(true);
  }

  // Wait for SSO service initialization if not immediately authenticated
  return from(ssoService.waitForInitialization()).pipe(
    map(isAuthenticated => {
      console.log('Auth Guard: SSO initialization complete, authenticated?', isAuthenticated);
      
      if (isAuthenticated) {
        return true;
      }
      
      // No authentication found, redirect to login
      console.log('Auth Guard: No authentication found, redirecting to login');
      router.navigateByUrl('/login');
      return false;
    }),
    catchError(error => {
      console.error('Auth Guard: Error during authentication check:', error);
      router.navigateByUrl('/login');
      return of(false);
    })
  );
};
